
import { ContentItem } from "../content-card/types";
import ContentDisplay from "../ContentDisplay";
import LoadingState from "../LoadingState";
import EmptyCollectionState from "../EmptyCollectionState";
import { ViewMode } from "@/hooks/usePersistentViewMode";

interface CollectionContentProps {
  contentItems: ContentItem[];
  isLoading: boolean;
  viewMode: ViewMode;
  onContentClick: (id: string) => void;
  onDeleteContent: (id: string) => void;
  onEditContent?: (id: string, currentTitle: string) => void;
  onArchiveContent?: (id: string) => void;
  onPin?: (id: string) => void;
  onUnpin?: (id: string) => void;
  collectionColor?: string | null;
  onAddContent?: () => void;
}

const CollectionContent = ({ 
  contentItems,
  isLoading,
  viewMode,
  onContentClick,
  onDeleteContent,
  onEditContent,
  onArchiveContent,
  onPin,
  onUnpin,
  collectionColor,
  onAddContent
}: CollectionContentProps) => {
  console.log("[COLOR DEBUG] CollectionContent using collection color:", collectionColor);
  
  // Debug pinned items
  const pinnedItems = contentItems.filter(item => item.pinned);
  console.log(`[PIN DEBUG] CollectionContent - Total items: ${contentItems.length}, Pinned items: ${pinnedItems.length}`);
  if (pinnedItems.length > 0) {
    console.log(`[PIN DEBUG] CollectionContent - Pinned items:`, pinnedItems.map(item => `${item.title} (${item.id})`));
  }
  
  if (isLoading) {
    return <LoadingState />;
  }

  if (contentItems.length === 0) {
    return <EmptyCollectionState onAddContent={onAddContent || (() => {})} />;
  }

  return (
    <ContentDisplay
      contentItems={contentItems}
      viewMode={viewMode}
      onContentClick={onContentClick}
      onDeleteContent={onDeleteContent}
      onEditContent={onEditContent}
      onArchiveContent={onArchiveContent}
      onPin={onPin}
      onUnpin={onUnpin}
      collectionColor={collectionColor}
    />
  );
};

export default CollectionContent;
